import { styled, Icon } from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import React from 'react';

var Container = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        '.arrow-text': {
            fontSize: 14,
            fontWeight: 600,
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            color: theme.palette.primary.main,
            margin: "5px 0",
            ':hover': {
                cursor: 'pointer',
            },
        },
    });
});
var IconComponent = (React.createElement(Icon, { sx: function (theme) { return ({ color: theme.palette.primary.main }); } },
    React.createElement(ArrowRightAltIcon, null)));
var ArrowLink = function (_a) {
    var text = _a.text, url = _a.url, Link = _a.Link, onTextClick = _a.onTextClick;
    var handleClick = function () {
        if (onTextClick)
            onTextClick();
    };
    return (React.createElement(Container, null, Link && url ? (React.createElement(Link, { to: url, style: { textDecoration: 'none' }, className: "arrow-text" },
        text,
        IconComponent)) : (React.createElement("div", { onClick: handleClick, className: "arrow-text" },
        text,
        IconComponent))));
};

export { ArrowLink };
//# sourceMappingURL=ArrowLink.js.map
